import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaMobileAlt,
  FaApple,
  FaAndroid,
  FaCogs,
  FaRocket,
} from "react-icons/fa";

export default function Soft() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <FaMobileAlt />,
      title: "Mobile App Development",
      desc: "Custom Android & iOS apps built for performance and scalability.",
    },
    {
      icon: <FaApple />,
      title: "iOS Apps",
      desc: "Premium iPhone & iPad apps with smooth UI/UX experience.",
    },
    {
      icon: <FaAndroid />,
      title: "Android Apps",
      desc: "High-performance Android apps optimized for all devices.",
    },
    {
      icon: <FaCogs />,
      title: "App Maintenance",
      desc: "Continuous updates, bug fixes, and performance improvements.",
    },
    {
      icon: <FaRocket />,
      title: "App Launch & Scaling",
      desc: "Deploy, optimize, and scale your app for real users.",
    },
  ];

  return (
    <div className="bg-white text-gray-900 min-h-screen">
      <Header />

      {/* 🔥 HERO (APP DEV) */}
      <section className="max-w-6xl mx-auto px-6 py-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-tight">
            Build powerful mobile applications
          </h1>

          <p className="mt-5 text-gray-500 max-w-xl mx-auto">
            We design and develop modern mobile apps that deliver seamless user experience and business growth.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
          >
            Start App Project
          </button>
        </motion.div>
      </section>

      {/* 💎 SERVICES */}
      <section className="max-w-6xl mx-auto px-6 pb-24 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -4 }}
            className="group p-6 rounded-2xl border border-gray-200 hover:border-gray-300 transition bg-white"
          >
            <div className="text-2xl text-gray-800 mb-4">
              {s.icon}
            </div>

            <h3 className="text-lg font-semibold mb-2">
              {s.title}
            </h3>

            <p className="text-sm text-gray-500">
              {s.desc}
            </p>

            <button
              onClick={() => navigate("/quotes")}
              className="mt-4 text-sm text-black font-medium hover:underline"
            >
              Learn more →
            </button>
          </motion.div>
        ))}
      </section>

      {/* 🚀 CTA */}
      <section className="border-t border-gray-200 py-20 text-center">
        <h2 className="text-3xl font-semibold">
          Ready to build your mobile app?
        </h2>

        <button
          onClick={() => navigate("/contact")}
          className="mt-6 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
        >
          Contact Us
        </button>
      </section>

      <Footer />
    </div>
  );
}